export const profileConstants = {
  DELETE: 'PROFILE_DELETE',

  PASSWORD_CHANGE: 'PROFILE_PASSWORD_CHANGE'
}